import benefits_en from './benefits_en.json'
import changeInsuredProduct_en from './change-insured-product_en.json'
import distributeBenefits_en from './distribute-benefits_en.json'
import errorPage_en from './error-page_en.json'
import findMember_en from './find-member_en.json'
import forms_en from './forms_en.json'
import insurancePlans_en from './insurance-plans_en.json'
import insuranceStatus_en from './insurance-status_en.json'
import insuranceToggle_en from './insurance-toggle_en.json'
import interactions_en from './interactions.json'
import overviewWidget_en from './overview-widget_en.json'
import restricted_en from './restricted_en.json'

const baseUSFlow_resources = {
  en: {
    ...forms_en,
    ...errorPage_en,
    ...benefits_en,
    ...insuranceToggle_en,
    ...insurancePlans_en,
    ...distributeBenefits_en,
    ...changeInsuredProduct_en,
    ...overviewWidget_en,
    ...interactions_en,
    ...insuranceStatus_en,
    ...restricted_en,
    ...findMember_en,
  },
}

export default baseUSFlow_resources
